import create, {prepare} from '~/misc/create';
import types from './types';
import * as api from './api';
import get from 'lodash/get';

import HTTPError from '~/misc/HTTPError';
import {promiseAction, ActionError} from '~/misc/dispatch';
import store from "~/store";
import {getUrlQeury, makeUrlQueryString} from "~/misc/formatUrlquery";
import {globalUrlParams} from "~/config";

export const getSwitchTimes = () => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.SWITCH_TIMES,
  api.asyncTimesSwitch(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

const vs = {holdParams: {}}

export const updateGlobalParams = () => (dispatch, getState) => {
  const holdParams = vs.holdParams;
  const params = getUrlQeury();
  const shouldAdd = [];
  var prefix = "";
  var shouldUpdate = false;
  let allParams = [].concat(globalUrlParams.global)
  let currentRouter = window.location.pathname
  let router = globalUrlParams.router.filter(item => {
    if (item.regExp && item.regExp.test(currentRouter)) {
      return true
    } else if (!item.regExp && item.path && item.path === currentRouter) {
      return true
    }
    return false
  })
  allParams = router.length ? allParams.concat(router[0].params) : allParams
  if (!params) {
    prefix = "?";
    allParams.forEach((x) => {
      if (holdParams[x]) {
        shouldAdd.push(`${x}=${holdParams[x]}`);
      }
    })
  } else {
    prefix = "&"
    allParams.forEach((x) => {
      if (!holdParams[x] && params[x]) {
        holdParams[x] = params[x];
        shouldUpdate = true;
      } else if (holdParams[x] && !params[x]){
        shouldAdd.push(`${x}=${holdParams[x]}`);
      }
    })
  }
  if (shouldUpdate) {
    dispatch(create(types.GLOBAL_PARAMS, holdParams))
  }
  if (shouldAdd.length > 0) {
    window.history.replaceState({}, 0, `${window.location.href}${prefix}${shouldAdd.join('&')}`)
  }

}

export const clearRouterParams = (router) => (dispatch, getState) => {
  if (router) {
    const params = getUrlQeury();
    let routerList = globalUrlParams.router.filter(item => {
      if (item.regExp && item.regExp.test(router)) {
        return true
      } else if (!item.regExp && item.path && item.path === router) {
        return true
      }
      return false
    })
    let clearList = routerList.length ? routerList[0].params : [];
    clearList.forEach(item => {
      delete vs.holdParams[item]
      delete params[item]
    })
    dispatch(create(types.GLOBAL_PARAMS, vs.holdParams))
    window.history.replaceState({}, 0, `${window.location.origin}${window.location.pathname}?${makeUrlQueryString(params)}`)
  }
}

export const clearGlobalParams = () => (dispatch, getState) => {
  const params = getUrlQeury();
  globalUrlParams.logOutDelete.forEach(item => {
    delete vs.holdParams[item]
    delete params[item]
  })
  dispatch(create(types.GLOBAL_PARAMS, vs.holdParams))
  window.history.replaceState({}, 0, `${window.location.origin}${window.location.pathname}?${makeUrlQueryString(params)}`)
}
export const windowFocused = prepare(types.WINDOW_FOCUSED);
export const windowBlurred = prepare(types.WINDOW_BLURRED);



// WEBPACK FOOTER //
// ./src/modules/window/actions.js